// src/icons/DollarIcon.tsx
import React from "react";

export function DollarIcon({
  className = "",
  ...props
}: React.SVGProps<SVGSVGElement> & { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M16 8.5c0-2-1.79-3-4-3s-4 1-4 3c0 2 1.5 3 4 4s4 2 4 4c0 2-1.79 3-4 3s-4-1-4-3" />
      <line x1="12" y1="4" x2="12" y2="21" />
    </svg>
  );
}
